let timeoutId;
export default (func, wait) => {
  clearTimeout(timeoutId);
  timeoutId = setTimeout(func, wait);
};
